import { useEffect } from 'react'

import { DisplayOptions, initialize, getInAppMessages } from '@iterable/web-sdk'

function useIterableInAppMessages(pageConfig) {
  const iterableInBrowserMessageApiKey =
    pageConfig?.iterableInBrowserMessageApiKey
  const iterableJwt = pageConfig?.iterableJwt
  const currentUserEmail = pageConfig?.currentUserEmail

  useEffect(() => {
    let isMounted = true

    const initializeIterable = async () => {
      if (
        typeof window === 'undefined' ||
        !iterableInBrowserMessageApiKey ||
        !iterableJwt ||
        !currentUserEmail
      ) {
        return
      }

      const { setEmail } = initialize(
        iterableInBrowserMessageApiKey,
        async () => iterableJwt
      )

      await setEmail(currentUserEmail)

      if (isMounted) {
        const inAppMessages = getInAppMessages(
          {
            count: 20,
            packageName: 'dev-site',
          },
          {
            display: DisplayOptions.Immediate,
          }
        )

        await inAppMessages.request()
      }
    }

    initializeIterable()

    return () => {
      isMounted = false
    }
  }, [currentUserEmail, iterableInBrowserMessageApiKey, iterableJwt])
}

export default useIterableInAppMessages
